// extracted by mini-css-extract-plugin
export default {"button":"NewVariantAdd_button__bfQLW","plus":"NewVariantAdd_plus__hKM9Y"};